// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Remove: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13">
            <path
                fill="currentColor"
                d="M.75 11.375c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.504 1.125-1.125V3.5h-9v7.875Zm6.375-6c0-.208.166-.375.375-.375s.375.167.375.375v5.25A.374.374 0 0 1 7.5 11a.374.374 0 0 1-.375-.375v-5.25Zm-2.25 0c0-.208.166-.375.375-.375s.375.167.375.375v5.25A.374.374 0 0 1 5.25 11a.374.374 0 0 1-.375-.375v-5.25Zm-2.25 0C2.625 5.167 2.791 5 3 5s.375.167.375.375v5.25A.373.373 0 0 1 3 11a.373.373 0 0 1-.375-.375v-5.25Zm7.5-4.125H7.5L7.229.707A.375.375 0 0 0 6.893.5H3.607a.375.375 0 0 0-.335.207L3 1.25H.375A.375.375 0 0 0 0 1.625v.75c0 .207.168.375.375.375h9.75a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375Z"
            />
        </svg>
    );
};

export default React.memo(Remove);
